import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../../../common/Modal';
import Spinner from '../../../../../../common/Spinner';

const DisconnectMailchimp = ({ loadingIsOn, handleDisconnect, openedIsOn, openedOn, openedOff }) => (
  <Fragment>
    <button
      type="button"
      className="c-btn c-btn--medium c-btn--red"
      onClick={openedOn}
    >
      <span className="c-btn__text">Disconnect</span>
    </button>
    <Modal
      className="mailchimp-modal mailchimp-disconnect"
      display-if={openedIsOn}
      title="Disconnect Mailchimp"
      close={openedOff}
      showCloseButton
    >
      <div className="modal-container">
        <div className="modal-container__body">
          <Fragment display-if={!loadingIsOn}>
            Are you sure you wish to disconnect your Mailchimp Integration?
            <p>Squire will stop sending data to Mailchimp.</p>
            <p>Reconnecting in the future will require us to resync all account data.</p>
          </Fragment>

          <Spinner display-if={loadingIsOn} />
        </div>
      </div>
      <div className="modal-controls">
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--grey"
          onClick={openedOff}
        >
          Cancel
        </button>
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--red"
          onClick={handleDisconnect}
        >
          Disconnect
        </button>
      </div>
    </Modal>
  </Fragment>
);
DisconnectMailchimp.propTypes = {
  loadingIsOn: PropTypes.bool.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
  openedOff: PropTypes.func.isRequired,
  openedOn: PropTypes.func.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
};

export default DisconnectMailchimp;
